import type { ReplyType, TabType } from "./types"

export type ComposeMode = "reply" | "replyAll" | "comment" | "forward"

export function getComposeMode({
	activeTab,
	isForwardMode,
	isReplyAllMode,
}: {
	activeTab: TabType
	isForwardMode: boolean
	isReplyAllMode: boolean
}): ComposeMode {
	if (isForwardMode) return "forward"
	if (activeTab === "comment") return "comment"
	if (isReplyAllMode) return "replyAll"
	return "reply"
}

export type ComposeModeIconKey = ComposeMode | "slack" | "chatReply"

export function getComposeModeIconKey({
	mode,
	replyType,
}: {
	mode: ComposeMode
	replyType: ReplyType
}): ComposeModeIconKey {
	if (mode !== "reply") return mode
	if (replyType === "slack") return "slack"
	if (replyType === "email") return "reply"
	return "chatReply"
}

export function getComposeModeLabel({
	mode,
	replyType,
}: {
	mode: ComposeMode
	replyType: ReplyType
}): string {
	switch (mode) {
		case "replyAll":
			return "Reply all"
		case "comment":
			return "Comment"
		case "forward":
			return "Forward"
		case "reply":
			if (replyType === "slack") return "Reply in Slack"
			if (replyType === "teams") return "Teams"
			return "Reply"
	}
}
